export default function redirect(loc) {
  window.location = loc;
}



// WEBPACK FOOTER //
// ./app/utils/redirect.js